import { render } from "./approvedModal.vue?vue&type=template&id=03bf9d42"
import script from "./approvedModal.vue?vue&type=script&lang=js"
export * from "./approvedModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__